/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Admin_Invite_Url_LabelInputs */



/**
* | output |
* | --- |
* | "Invite link — share it with the first admin" |
*
* @param {Partner_Admin_Invite_Url_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_admin_invite_url_label = /** @type {((inputs?: Partner_Admin_Invite_Url_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Admin_Invite_Url_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Einladungslink — teile ihn mit dem ersten Admin")
	return /** @type {LocalizedString} */ ("Invite link — share it with the first admin")
});